import React from 'react';

import Page from 'components/Page';
import ImageBackground from 'components/ImageBackground';


const ImageTemplate = ({ page: { acf: { image, image_fit, background_color } } }) => {
    return (
        <Page>
            <ImageBackground src={image?.sizes?.['2048x2048']} imageFit={image_fit} bgColor={background_color}/>
        </Page>
    );
};


export default ImageTemplate;
